import React, { Component } from 'react';
import _ from 'lodash';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import {
	WithStyles,
	createStyles,
	Grid,
	Card,
	CardContent,
	Typography,
	Avatar,
} from '@material-ui/core';
import {
	CloseOutlined as CloseIcon,
	Check as SelectedIcon
} from '@material-ui/icons';
import {
	MyPATDialog,
	MyPATIconButton,
	MyPATTextField,
	MyPATTextArea,
	SearchField,
} from '../../common';
import GroupIconGrid from './GroupIconGrid';

import { UserBody } from '../types/UsersBody';
import { UserGroupsBody } from '../types/UserGroupsBody';
import userGroupsServices from '../services/userGroupsServices';
import { usersList } from '../actions/usersActions';
import { userGroupsList, getUserGroupsCount } from '../actions/userGroupsActions';

const styles = (theme: Theme) => createStyles({
	mb1x: {
		marginBottom: theme.spacing.unit,
	},
	mb2x: {
		marginBottom: theme.spacing.unit * 2,
	},
	textCenter: {
		textAlign: 'center',
	},
	textCapitalize: {
		textTransform: 'capitalize'
	},
	pointer: {
		cursor: 'pointer',
	},
	cardContentRootMain: {
		...theme.mixins.gutters(),
		paddingTop: theme.spacing.unit * 2,
		paddingBottom: theme.spacing.unit * 2,
		'&:last-child': {
			paddingBottom: theme.spacing.unit * 2,
		},
	},
	cardContentRoot: {
		padding: `${theme.spacing.unit}px ${theme.spacing.unit * 2}px`,
		'&:last-child': {
			paddingBottom: theme.spacing.unit,
		},
	},
	dialogCloseContainer: {
		textAlign: 'right',
	},
	borderBox: {
		border: `1px solid ${theme.palette.grey[300]}`,
		borderRadius: theme.shape.borderRadius,
		padding: theme.spacing.unit,
	},

	searchInputRoot: {
		border: `1px solid ${theme.palette.grey[300]}`,
		borderRadius: theme.shape.borderRadius,
		paddingLeft: theme.spacing.unit,
		paddingRight: theme.spacing.unit,
		marginBottom: theme.spacing.unit,
	},

	avatarWrapper: {
		position: 'relative',
		marginRight: theme.spacing.unit,
		'& > div': {
			height: theme.spacing.unit * 7,
			width: theme.spacing.unit * 7,
			'& > svg': {
				fontSize: theme.spacing.unit * 4,
			}
		}
	},
	selectedIcon: {
		color: theme.palette.common.white,
		backgroundColor: 'rgba(114, 201, 54, 0.63)',
		position: 'absolute',
		zIndex: 1,
	},

	selectedUsersGrid: {
		maxWidth: 'initial !important',
		overflowX: 'auto',
		overflowY: 'hidden',
	},
	selectedUserAvatar: {
		flexShrink: 0,
		position: 'relative',
		cursor: 'pointer',
		textAlign: 'center',
		'& > div': {
			margin: '0 auto',
			height: theme.spacing.unit * 7,
			width: theme.spacing.unit * 7,
		},
		'& > span': {
			fontSize: theme.typography.fontSize,
		}
	},
	removeIcon: {
		top: theme.spacing.unit / 2,
		left: '50%',
		transform: 'translateX(50%)',
		backgroundColor: theme.palette.grey[500],
		position: 'absolute',
		borderRadius: '50%',
		color: theme.palette.common.white,
		margin: `1px 2px`,
		boxShadow: theme.shadows[1],
		fontSize: theme.spacing.unit * 2,
	},

	userWrapper: {
		overflowX: 'hidden',
		overflowY: 'auto',
		maxHeight: 240,
		padding: theme.spacing.unit,
	},

	roleName: {
		display: 'inline-block',
		textTransform: 'capitalize',
		marginRight: theme.spacing.unit / 2,
		'&:after': {
			content: '","',
		},
		'&:last-child': {
			marginRight: 0,
			'&:after': {
				display: 'none',
			}
		}
	}
});

const defaultFormData = {
	name: '',
	description: '',
	usersId: [],
}

interface AddUserGroupDialogProps extends WithStyles<typeof styles> {
	dialogOpen: boolean,
	dialogCloseHandler: Function,
	getUserGroupsCount: () => void,
	usersList: () => void,
	users: UserBody[],
	userGroups: {
		list: UserGroupsBody[],
		count: number,
	},
	userGroupsList: () => void,
	dialogData: string,
}

interface AddUserGroupDialogState {
	formData: {
		name: string,
		description: string,
		usersId: any[],
	},
	searchValue: string,
	tempSelectedUsersId: any[],
	errors: any,
}

class AddUserGroupDialog extends Component<AddUserGroupDialogProps, AddUserGroupDialogState> {
	constructor(props: AddUserGroupDialogProps) {
		super(props);
		this.state = {
			formData: defaultFormData,
			searchValue: '',
			tempSelectedUsersId: [],
			errors: {
				name: '',
			},
		};

		this.handleDialogSave = this.handleDialogSave.bind(this);
		this.handleDialogDelete = this.handleDialogDelete.bind(this);
		this.handleSearchChange = this.handleSearchChange.bind(this);
		this.handleInputChange = this.handleInputChange.bind(this);
		this.handleAddRemoveUserClick = this.handleAddRemoveUserClick.bind(this);
	}

	componentDidMount() {
		!_.isEmpty(this.props.dialogData) && this.populateForEdit();
	}
	componentWillUnmount() {
		this.resetForm();
	}

	populateForEdit = () => {
		if (this.props.userGroups.list) {
			let a = _.find(this.props.userGroups.list, ['_id', this.props.dialogData]);
			if (a) {
				let groupData1: any = JSON.parse(JSON.stringify(a));
				let groupData2: any = JSON.parse(JSON.stringify(a));
				this.setState({
					formData: {
						name: groupData1.name,
						description: groupData1.description,
						usersId: groupData1.usersId,
					},
					tempSelectedUsersId: groupData2.usersId,
				});
			}
		}
	}

	resetForm = () => {
		this.setState({
			formData: defaultFormData,
			tempSelectedUsersId: [],
			searchValue: '',
			errors: {
				name: '',
			}
		});
	}

	generateRemovedUsersId = (selectedUsersId: any[]) => {
		let removedUsersId = _.map(this.state.formData.usersId, ({ _id }: any) => _id);
		removedUsersId = _.filter(removedUsersId, id => !_.includes(selectedUsersId, id));
		return removedUsersId;
	}

	handleDialogSave = () => {
		const { name, description } = this.state.formData;
		if (_.isEmpty(name)) {
			return this.setState({ errors: { name: 'Name is required' } });
		}
		const selectedUsersId = _.map(this.state.tempSelectedUsersId, ({ _id }: any) => _id);
		const removedUsersId = this.generateRemovedUsersId(selectedUsersId);

		const postData: any = {
			name,
			description,
			usersId: selectedUsersId,
			removedUsersId,
		};
		_.isEmpty(this.props.dialogData)
			? userGroupsServices.create(postData).then(res => {
				this.props.userGroupsList();
				this.props.usersList();
				this.props.getUserGroupsCount();
				this.props.dialogCloseHandler();
			})
			: userGroupsServices.update(postData, this.props.dialogData).then(res => {
				this.props.userGroupsList();
				this.props.usersList();
				this.props.dialogCloseHandler();
			});
	}

	handleDialogDelete = () => {
		userGroupsServices.remove(this.state.formData.name, this.props.dialogData).then(res => {
			this.props.userGroupsList();
			this.props.usersList();
			this.props.getUserGroupsCount();
			this.props.dialogCloseHandler();
		});
	}

	handleInputChange = (evt: any) => {
		let formData: any = this.state.formData;
		formData[evt.target.name] = evt.target.value;
		this.setState({ formData: { ...this.state.formData, ...formData } });
	}

	handleInputBlur = (evt: any) => {
		if (_.isEqual(evt.target.name, 'name')) {
			if (_.isEmpty(evt.target.value)) {
				let { errors }: any = this.state;
				errors.name = 'Name is required';
				return this.setState({ errors });
			} else {
				return this.setState({ errors: { name: '' } });
			}
		}
	}

	handleSearchChange = (evt: any) => this.setState({ searchValue: evt.target.value });

	handleAddRemoveUserClick = (actionType: 'add' | 'remove', user: any) => {
		let { tempSelectedUsersId } = this.state;
		const { _id, fullName, profileImage } = user;

		if (_.isEqual(actionType, 'add')) {
			tempSelectedUsersId.push({ _id, fullName, profileImage });
		} else {
			tempSelectedUsersId.splice(_.findIndex(tempSelectedUsersId, ['_id', _id]), 1);
		}
		this.setState({ tempSelectedUsersId });
	}

	getActionType = (userId: string) => (_.findIndex(this.state.tempSelectedUsersId, ['_id', userId]) >= 0) ? 'remove' : 'add';

	render() {
		const {
			classes,
			dialogOpen,
			dialogCloseHandler,
			users,
			dialogData
		} = this.props;
		const {
			searchValue,
			formData,
			tempSelectedUsersId,
			errors
		} = this.state;
		const { name, description, usersId } = formData;

		const otherDialogProps = {
			fullWidth: true,
			maxWidth: 'md',
			scroll: 'body',
		};

		return (
			<MyPATDialog
				dialogOpen={dialogOpen}
				otherDialogProps={otherDialogProps}
				onDialogSave={this.handleDialogSave.bind(this)}
				onDialogDelete={_.isEmpty(dialogData) ? undefined : this.handleDialogDelete.bind(this)}
				customDialogTitle={
					<Grid container justify="space-between" alignItems="center">
						<Grid item xs>
							{_.isEmpty(dialogData)
								? <Typography variant="h6"> Add User Group </Typography>
								: <Typography variant="h6"> Update User Group </Typography>
							}
						</Grid>

						<Grid item xs="auto" className={classes.dialogCloseContainer}>
							<MyPATIconButton buttonVariant="flat" onClick={dialogCloseHandler}>
								<CloseIcon />
							</MyPATIconButton>
						</Grid>
					</Grid>
				}
			>
				<Card className={classes.mb1x}>
					<CardContent className={classes.cardContentRootMain}>
						<Grid container alignItems="center">
							<Grid item xs={12} className={classes.mb1x}>
								<Typography variant="h6">Basic Info</Typography>
							</Grid>

							<Grid item xs={12} className={classes.mb1x}>
								<Typography variant="body1" gutterBottom>Group Name</Typography>
								<MyPATTextField
									inputId="name"
									name="name"
									placeholder="Enter group name to add the user"
									value={name}
									onChange={this.handleInputChange.bind(this)}
									onBlur={this.handleInputBlur.bind(this)}
									error={!_.isEmpty(errors.name)}
									errorText={!_.isEmpty(errors.name) ? errors.name : ''}
									fullWidthControl
								/>
							</Grid>

							<Grid item xs={12}>
								<Typography variant="body1" gutterBottom>Description</Typography>
								<MyPATTextArea
									inputId="description"
									name="description"
									placeholder="Write here..."
									rows="3"
									value={description}
									onChange={this.handleInputChange.bind(this)}
									multiline
									fullWidthControl
								/>
							</Grid>
						</Grid>
					</CardContent>
				</Card>

				<Card className={classes.mb1x}>
					<CardContent className={classes.cardContentRootMain}>
						<Grid container alignItems="center">
							<Grid item xs={12} className={classes.mb1x}>
								<Typography variant="h6">Add User</Typography>
							</Grid>

							{!_.isEmpty(tempSelectedUsersId) && (
								<Grid item xs={12} className={classes.selectedUsersGrid}>
									<Grid container alignItems="center" wrap="nowrap" spacing={8}>
										{_.map(tempSelectedUsersId, (user, userIndex) => (
											<Grid item xs="auto" key={`${user._id} ${userIndex}`}
												className={classes.selectedUserAvatar}
												onClick={this.handleAddRemoveUserClick.bind(this, 'remove', user)}
											>
												<Avatar alt={`Profile ${user.fullName}`} src={_.isEmpty(user.profileImage) ? "/assets/img/profile-default.png" : user.profileImage} />
												<Typography variant="caption" className={classes.textCapitalize} noWrap>{user.fullName}</Typography>
												<CloseIcon className={classes.removeIcon} />
											</Grid>
										))}
									</Grid>
								</Grid>
							)}

							<Grid item xs={12}>
								<div className={classes.borderBox}>
									<SearchField
										id="userSearch"
										placeholder="Search user"
										className={classes.searchInputRoot}
										onChange={this.handleSearchChange.bind(this)}
										value={searchValue}
										fullWidth
									/>
									<div className={classes.userWrapper}>
										{_.map(users, (user, userIndex) =>
											_.includes(_.toLower(user.fullName), _.toLower(searchValue)) && (
												<Card key={`${user._id} ${userIndex}`} className={`${classes.mb1x} ${classes.pointer}`}
													onClick={this.handleAddRemoveUserClick.bind(this, this.getActionType(user._id), user)}
												>
													<CardContent className={classes.cardContentRoot}>
														<Grid container alignItems="center" justify="space-between" spacing={8}>
															<Grid item xs="auto" className={classes.avatarWrapper}>
																{_.isEqual(this.getActionType(user._id), 'remove') && <Avatar className={classes.selectedIcon}><SelectedIcon /></Avatar>}
																<Avatar alt={`Profile ${user.fullName}`} src={_.isEmpty(user.profileImage) ? "/assets/img/profile-default.png" : user.profileImage} />
															</Grid>

															<Grid item xs>
																<Typography variant="h5" noWrap>
																	<strong className={classes.textCapitalize}>{user.fullName}</strong>
																</Typography>
																{_.map(user.roles, (role, rIndex) => (
																	<Typography key={`role_${rIndex}`} variant="body1" className={classes.roleName}>
																		{_.get(role, 'roleId.role', '')}
																	</Typography>
																))}
															</Grid>

															<Grid item xs="auto" className={classes.textCenter}>
																<GroupIconGrid
																	groupColor={_.get(user, 'groupsId[0].groupColor', '')}
																	groupName={_.get(user, 'groupsId[0].name', '')}
																	otherGroups={user.groupsId}
																/>
															</Grid>
														</Grid>
													</CardContent>
												</Card>
											))}
									</div>
								</div>
							</Grid>
						</Grid>
					</CardContent>
				</Card>
			</MyPATDialog>
		);
	}
}

const mapStateToProps = (state: any) => ({
	userGroups: _.get(state, 'userManagement.userGroups', {}),
	users: _.get(state, 'userManagement.users.list', []),
});

const mapDispatchToProps = (dispatch: any) => bindActionCreators({
	userGroupsList,
	getUserGroupsCount,
	usersList,
}, dispatch);

// @ts-ignore
export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(AddUserGroupDialog));